import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { FirmwareGroup } from './firmwareGroups.types';

const firmwareGroupsApiPath = '/firmwares/groups';

export const getFirmwareGroups = async (): Promise<AxiosResponse<FirmwareGroup[] & ApiError>> => {
  return instance.get<FirmwareGroup[]>(firmwareGroupsApiPath).catch(e => e.response as AxiosError<ApiError> as never);
};

export const createFirmwareGroup = async (data: FirmwareGroup): Promise<AxiosResponse<FirmwareGroup & ApiError>> => {
  return instance
    .post<FirmwareGroup>(firmwareGroupsApiPath, data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const firmwareGroupApiPath = (id: number) => `/firmwares/group/${id}`;

export const updateFirmwareGroup = async (data: FirmwareGroup): Promise<AxiosResponse<FirmwareGroup & ApiError>> => {
  return instance
    .post<FirmwareGroup>(firmwareGroupApiPath(data.id), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteFirmwareGroup = async ({ id }: { id: number }): Promise<AxiosResponse<FirmwareGroup & ApiError>> => {
  return instance
    .delete<FirmwareGroup>(firmwareGroupApiPath(id))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
